module.exports = __webpack_public_path__ + "static/background3-827d1de7ecf7ee9098617d051aeafe47.jpg";